module.exports = __webpack_public_path__ + "static/media/Sportitalia.406a6c74.png";